import { render, staticRenderFns } from "./TheModaSignoVitales.vue?vue&type=template&id=28afa1f9&scoped=true&"
import script from "./TheModaSignoVitales.vue?vue&type=script&lang=js&"
export * from "./TheModaSignoVitales.vue?vue&type=script&lang=js&"
import style0 from "./TheModaSignoVitales.vue?vue&type=style&index=0&id=28afa1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afa1f9",
  null
  
)

export default component.exports